import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaUser, FaRobot, FaBrain, FaMagic } from "react-icons/fa";

function HowItWorksSectionComponent() {
  return (
    <section className="bg-dark section-spacing ">
      <Container>
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3 landing-page-text">How AskLMS Works</h2>
          <p className="lead text-muted mx-auto " style={{ maxWidth: "700px" }}>
            Simple, powerful, and intuitive. Get started in minutes and harness
            the power of multiple AI models.
          </p>
        </div>
        <Row className="g-4 justify-content-center">
          <Col md={4} className="text-center">
            <div className="animate-on-scroll">
              <div className="bg-dark p-4 rounded-4 h-100">
                <div className="d-flex justify-content-center mb-4">
                  <div className="feature-icon d-flex align-items-center justify-content-center">
                    <FaUser size={32} />
                  </div>
                </div>
                <h3 className="h4 mb-3 landing-page-text">1. Sign Up</h3>
                <p className="text-muted mb-0 landing-page-text">
                  Create your free account in seconds. No credit card required
                  to get started with basic access.
                </p>
              </div>
            </div>
          </Col>
          <Col md={4} className="text-center">
            <div className="animate-on-scroll">
              <div className="bg-dark p-4 rounded-4 h-100">
                <div className="d-flex justify-content-center mb-4">
                  <div className="feature-icon d-flex align-items-center justify-content-center">
                    <FaRobot size={32} />
                  </div>
                </div>
                <h3 className="h4 mb-3 landing-page-text">
                  2. Choose Your Model
                </h3>
                <p className="text-muted mb-0">
                  Select from our range of powerful AI models based on your
                  specific needs and tasks.
                </p>
              </div>
            </div>
          </Col>
          <Col md={4} className="text-center">
            <div className="animate-on-scroll">
              <div className="bg-dark p-4 rounded-4 h-100">
                <div className="d-flex justify-content-center mb-4">
                  <div className="feature-icon d-flex align-items-center justify-content-center">
                    <FaBrain size={32} />
                  </div>
                </div>
                <h3 className="h4 mb-3 landing-page-text">3. Ask Anything</h3>
                <p className="text-muted mb-0">
                  Type your questions, prompts, or commands. Our AI models will
                  process your request instantly.
                </p>
              </div>
            </div>
          </Col>
          <Col md={6} className="text-center mt-4">
            <div className="animate-on-scroll">
              <div className="bg-dark p-4 rounded-4 h-100">
                <div className="d-flex justify-content-center mb-4">
                  <div className="feature-icon d-flex align-items-center justify-content-center">
                    <FaMagic size={32} />
                  </div>
                </div>
                <h3 className="h4 mb-3 landing-page-text">4. Get Results</h3>
                <p className="text-muted mb-0">
                  Receive accurate, helpful responses or generated content.
                  Compare different models' outputs if needed.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default HowItWorksSectionComponent;
